import { mapActions, mapGetters, mapMutations } from "vuex";

import Moment from "moment";
import { extendMoment } from "moment-range";
import { mixin as clickaway } from "vue-clickaway";
import { audioPlay } from "@/utils/audio-play";
import tokenUtils from "@/utils/tokens";

// components
import Bell from "./components/notification-tooltip/components/bell.vue";
import Courses from "./components/courses-tooltip/index.vue";
import Notifications from "./components/notification-tooltip/index.vue";
import Profile from "./components/profile-tooltip/index.vue";
import Navigation from "./components/navigation/index.vue";
import MobileHeader from "./components/mobile/index.vue";
import testsHeader from "./components/tests-header/index.vue";
import homeWorkHeader from "./components/home-work-header/index.vue";
import graduateWorkHeader from "./components/graduate-work-header/index.vue";
import headerSearch from "./components/header-search/index.vue";
import lessonStatistic from "./components/lesson-statistic/index.vue";

const moment = extendMoment(Moment);

export default {
	name        : "main-header",
	mixins      : [clickaway],
	data() {
		return {
			showCourses : false,
			options     : {},
		};
	},
	components  : {
		Courses,
		Notifications,
		Profile,
		Navigation,
		MobileHeader,
		headerSearch,
		testsHeader,
		lessonStatistic,
		homeWorkHeader,
		graduateWorkHeader,
		Bell,
	},
	computed    : {
		...mapGetters({
			user                    : `user/user`,
			isAuthenticated         : `auth/isAuthenticated`,
			isOpenMenu              : `system/openMenu`,
			isOpenSecondMenu        : `system/openSecondMenu`,
			isOpenFirstMenu         : `system/openFirstMenu`,
			propsSecondMenu         : `system/propsSecondMenu`,
			showTooltipCourses      : "header/showTooltipCourses",
			showTooltipNotification : "header/showTooltipNotification",
			showTooltipProfile      : "header/showTooltipProfile",
			openSearch              : `system/openSearch`,
			testHeader              : "tests/header",
			homeWorkHeader          : "coursesHomeWork/header",
			graduateWorkHeader      : "coursesGraduateWork/header",
			notificationsReadedCount: "header/notificationsReadedCount",
			notificationsList       : "header/notificationsList",
			openNotification        : "userPayments/openNotification"
		}),
		imgNotifications() {
			return require("@/assets/img/svg/bell.svg");
		},
		imgAvatar() {
			if (this.user)
				return this.user.personalData.data.avatar !== ""
					? this.user.personalData.data.avatar
					: require("@/assets/img/default-avatar.jpg");
			return require("@/assets/img/default-avatar.jpg");
		},
		userId() {
			if (this.user) return this.user.id;
		},
	},
	watch: {
		user                : {
			handler() {
				//console.log('header watch user');
				
				if(this.user != null){
					//this.loadData();
				}
			},
			deep: true
		},
		openNotification    : {
			handler() {
				//console.log('header watch openNotification:', this.openNotification);
			},
			deep: true
		},
		$route() {
			if (
				this.showTooltipCourses ||
				this.showTooltipNotification ||
				this.showTooltipProfile
			) {
				this.changeShowCoursesTooltip(false);
				this.changeShowNotificationTooltip(false);
				this.changeShowProfileTooltip(false);
			}
		},
	},
	created() {
		//console.log('header created');
		
		moment.locale(this.$route.params.lang);
		
		this.fetchList();
	},
	mounted() {
		//console.log('header mounted');
		
		this.$store.watch(
			() => this.userId,
			async () => {
				if (
					window.Echo.connector.pusher.config.auth == undefined ||
					window.Echo.connector.pusher.config.auth == null
				) {
					window.Echo.connector.pusher.config.auth = {};
				}
				
				if (
					window.Echo.connector.pusher.config.auth.headers == undefined ||
					window.Echo.connector.pusher.config.auth.headers == null
				) {
					window.Echo.connector.pusher.config.auth.headers = {};
				}
				
				window.Echo.connector.pusher.config.auth.headers["Authorization"] =
					"Bearer " + tokenUtils.getActualToken();
				
				window.Echo.private(`users.${this.userId}`).notification((e) => {
					this.fetchList();
					this.notificationsList.unshift(e);

					let str = e.subject;
					
					if (!this.$toasted.toasts.length) {
						audioPlay("/tone.mp3");
					}
					
					this.$toasted.success(str, {
						action: {
							onClick: (e, toastObject) => {
								toastObject.goAway(0);
								setTimeout(() => {
									this.changeShowTooltipNotifications();
								}, 100);
							},
						},
					});
				});
			}
		);
	},
	methods: {
		...mapActions({
			fetchList   : "header/HEADER_FETCH_NOTIFICATION_COURSES",
			authLogout  : "auth/AUTH_LOGOUT",
		}),
		...mapMutations({
			changeMenu                      : "system/CHANGE_MOBILE_MENU",
			changeShowCoursesTooltip        : "header/HEADER_COURSES_SHOW_TOOLTIP",
			changeShowNotificationTooltip   : "header/HEADER_NOTIFICATION_SHOW_TOOLTIP",
			changeShowProfileTooltip        : "header/HEADER_PROFILE_SHOW_TOOLTIP",
			changeSearch                    : "system/CHANGE_OPEN_SEARCH",
		}),
		logout() {
			this.authLogout();
			
			this.$router.push({
				name: "sing-in"
			});
		},
		awayCourse() {
			this.changeShowCoursesTooltip(false);
		},
		awayNotification() {
			this.changeShowNotificationTooltip(false);
		},
		awayProfile() {
			this.changeShowProfileTooltip(false);
		},
		removeToken() {
			this.logout();
			
			this.$router.push({
				name: "home"
			});
		},
		openHeaderSearch() {
			this.changeSearch(true);
		},
		changeCourseList() {
			if (!this.showTooltipCourses) {
				this.changeShowCoursesTooltip(true);
			} else {
				this.changeShowCoursesTooltip(false);
			}
		},
		changeShowTooltipNotifications() {
			if (!this.showTooltipNotification) {
				this.changeShowNotificationTooltip(true);
			} else {
				this.changeShowNotificationTooltip(false);
			}
		},
		changeShowProfileSidebar() {
			if (!this.showTooltipProfile) {
				this.changeShowProfileTooltip(true);
			} else {
				this.changeShowProfileTooltip(false);
			}
		},
	},
};
